/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
import { useState, useCallback } from 'react';

export function useGameUiToggles() {
  const [showPerformanceMonitor, setShowPerformanceMonitor] = useState(false);
  const [showEnhancedObjectives, setShowEnhancedObjectives] = useState(false);
  const [orgManagementOpen, setOrgManagementOpen] = useState<string | null>(null);
  const togglePerformanceMonitor = useCallback(() => setShowPerformanceMonitor(p => !p), []);
  const toggleEnhancedObjectives = useCallback(() => setShowEnhancedObjectives(p => !p), []);
  return {
    showPerformanceMonitor,
    togglePerformanceMonitor,
    showEnhancedObjectives,
    toggleEnhancedObjectives,
    orgManagementOpen,
    setOrgManagementOpen,
  };
}